var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.imageUrl)?_c('PictureComp',{attrs:{"imageProfile":"competitor_icon","imageUrl":_vm.getImageUrl(_vm.imageUrl),"alt":_vm.competitionName}}):_c('img',{attrs:{"src":_vm.fallbackSrc,"alt":_vm.competitionName}})
}
var staticRenderFns = []

export { render, staticRenderFns }